export default __webpack_public_path__ + "static/media/hero-image-2-mobile.f81d577b.png";